import * as React from 'react'
// libs
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
// components
import Menu, { Button } from '../Menu'
import { PopoverModal } from 'components/UI'
import { DateCalendar } from '@mui/x-date-pickers'
// context
import { StrategyActionsBLContext } from 'containers/StrategyActions/layers/BL'
// constants
import { Forms } from 'constants/index'
import { TIME_FRAME_FILTERS } from 'constants/home'
// themes
import { colors } from 'themes'
import MoreIcon from '@mui/icons-material/ArrowDropDown'
// utils
import moment from 'moment'

// styled
const Wrapper = styled('div')`
  align-items: center;
  color: ${colors.blue500};
  display: flex;

  & > :first-child {
    padding-right: 0;
  }
`

const selector = formValueSelector(Forms.HOME_PAGE_FILTER_FORM)

const TimeFrameFilter: React.FC = () => {
  const dispatch = useDispatch()

  const { handleSetTimeFrameFilter, timeFrameFilter } = React.useContext(StrategyActionsBLContext)

  const { startPeriod, endPeriod } = useSelector((state) => ({
    startPeriod: selector(state, 'startPeriod'),
    endPeriod: selector(state, 'endPeriod')
  }))

  const TIME_FRAME_FILTER_OPTIONS = [
    { label: 'All time', value: TIME_FRAME_FILTERS.ALL, onClick: handleSetTimeFrameFilter(TIME_FRAME_FILTERS.ALL) },
    {
      label: 'Custom time period',
      value: TIME_FRAME_FILTERS.CUSTOM,
      onClick: handleSetTimeFrameFilter(TIME_FRAME_FILTERS.CUSTOM)
    }
  ]

  const onDateChange = (field, closePopup, date) => {
    dispatch(change(Forms.HOME_PAGE_FILTER_FORM, field, date))

    closePopup()
  }

  return (
    <>
      <Menu
        title={TIME_FRAME_FILTER_OPTIONS.find((option) => option.value === timeFrameFilter).label}
        options={TIME_FRAME_FILTER_OPTIONS}
      />

      {timeFrameFilter === TIME_FRAME_FILTERS.CUSTOM && (
        <Wrapper>
          <PopoverModal
            trigger={
              <Button>
                {moment(startPeriod).format('D MMM YY')}
                <MoreIcon color={'inherit'} fontSize={'large'} />
              </Button>
            }
            disableRestoreFocus>
            {({ closePopup }) => (
              <DateCalendar
                maxDate={moment(endPeriod)}
                value={moment(startPeriod)}
                onChange={(date) => onDateChange('startPeriod', closePopup, date)}
              />
            )}
          </PopoverModal>
          -
          <PopoverModal
            trigger={
              <Button>
                {moment(endPeriod).format('D MMM YY')}
                <MoreIcon color={'inherit'} fontSize={'large'} />
              </Button>
            }
            disableRestoreFocus>
            {({ closePopup }) => (
              <DateCalendar
                value={moment(endPeriod)}
                minDate={moment(startPeriod)}
                onChange={(date) => onDateChange('endPeriod', closePopup, date)}
              />
            )}
          </PopoverModal>
        </Wrapper>
      )}
    </>
  )
}

export default TimeFrameFilter
